export const importMenu = {
	title: "Configurar Delivery e Integraciones",
	description: "Intégrese con un Delivery asociado y centralice su gestión en Zig.",
	info:
		'Algunos productos pueden tener elementos complementarios y opcionales. Podrá revisar más detalles y hacer ajustes en "Productos y Menús" después de la importación.',
	selectAllCategories: "Seleccionar todas las categorías",
	searchCategory: "Buscar categoría",
	amountItemsSelected: "<strong>{{amount}}</strong> elementos seleccionados",
	cancelBtn: "Cancelar",
	importItensSelected: "Importar elementos seleccionados",
	notProductFound: "Ningún producto encontrado",
	returnToMenu: "Volver al menú",
	menuNameByExternalType: "Menú de Delivery ({{externalType}})",
	importMenuError: {
		title: "No fue posible importar su menú",
		description:
			"Algo inesperado sucedió y no pudimos completar la importación. Complete su integración y finalice su menú más tarde.",
		completeWithoutMenuBtn: "Completar integración sin menú",
		retryBtn: "Intentar importar nuevamente",
	},
	importMenuSuccess: {
		title: "Su menú fue importado con éxito",
		description:
			'Puede gestionar sus menús en la pestaña "Menús" de este mismo módulo, además de gestionar sus productos en el módulo "Productos y Menús".',
		viewProductsBtn: "Ver productos",
	},
	integrationSuccess: {
		title: "Integración completada",
		description:
			'¡Su integración fue completada con éxito! Puede gestionar sus menús más tarde en el módulo "Productos y Menús".',
		viewProductsAndMenusBtn: "Ver productos y menús",
	},
	loadingMessage: "Espere mientras identificamos los elementos de su menú",
	loadingMutation: "Espere mientras completamos la integración",
	active: "Activo",
	inactive: "Inactivo",
};
